<template>
  <div>
    <div class="row-tb-head" style="margin-top: 10px">
      <span>装配信息</span>
    </div>
    <el-table
      ref="table"
      class="table_bottom table-line tb-c-head"
      :data="tableData"
      border
    >
      <el-table-column
        prop="ProductName"
        label="产品名称"
        min-width="160"
        align="center"
      >
      </el-table-column> 
      <el-table-column prop="ProductSpec" label="规格" min-width="110" align="center">
      </el-table-column>
      <el-table-column
          prop="PdUnitName"
          label="单位"
          min-width="126"
          align="center"
        >
        </el-table-column>
      <el-table-column
          prop="ColorName"
          label="颜色"
          min-width="126"
          align="center"
        >
        </el-table-column>
      <el-table-column
        prop="Quantity"
        label="需求数量"
        min-width="110"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="ImgUrl" label="图片" min-width="110" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="viewImg(row)">{{row.ProductId ? '查看' : ''}}</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="ProcessStage"
        label="加工阶段"
        min-width="110"
        align="center"
      >
        <template slot-scope="{ row }">
          <span>{{ row.ProcessStage === 3 ? '装配' : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="ProduceTypeName"
        label="存货类型"
        min-width="110"
        align="center"
      >
        <template slot-scope="{ row }">
          <span>{{ row.ProduceTypeName }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="Bomno"
        label="bom版本"
        min-width="110"
        align="center"
      >
      </el-table-column>
    </el-table>
      <div class="row-tb-head" style="margin-top: 10px">
        <span>工艺</span>
      </div>

    <el-table
      :data="ProcessData"
      class="table_bottom table-line tb-c-head"
      border
      ref="list3"
    >
      <el-table-column
        prop="ProductName"
        label="产品名称"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="ProductNo"
        label="产品编码"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="ProgrammeName"
        label="工艺方案名称"
        min-width="120"
      >
      </el-table-column>
       <el-table-column
        label="方案详情"
        min-width="120"
      >
        <template slot-scope="{ row }">
           <el-button type="text" @click="changeProgrammeInfo(row)">详情编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div  v-for="(item, index) in detailData" :key="index">
    <div class="row-tb-head" style="margin-top: 10px">
      <span>{{item.name}}子件信息</span>
    </div>
    <el-table
      ref="sub_table"
      class="table_bottom table-line tb-c-head"
      :data="item.DetailModels"
      border
    >
      <el-table-column
        prop="ProductNo"
        label="子件编码"
        min-width="110"
        align="center"
      >
        <template slot-scope="{ row }">
         <span>{{row.ProductNo}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="ProductName"
        label="子件名称"
        min-width="110"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="ProductSpec" label="规格" min-width="110" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.ProductSpec }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="PdUnitName"
          label="单位"
          min-width="126"
          align="center"
        >
        </el-table-column>
      <el-table-column prop="PropertyName" label="属性" min-width="110" align="center">
      </el-table-column>
     <el-table-column
          prop="ColorName"
          label="颜色"
          min-width="126"
          align="center"
        >
        </el-table-column>
      <el-table-column
        prop="Quantity"
        label="需求数量"
        min-width="120"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="ImgUrl" label="图片" min-width="110" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="viewImg(row)">{{row.ProductId ? '查看' : ''}}</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="ProcessStage"
        label="加工阶段"
        min-width="110"
        align="center"
      >
        <template slot-scope="{ row }">
          <span>{{ (() => {
                
                if(row.ProcessStage === 3){
                  return '装配'
                }else if(row.ProcessStage === 1){
                  return '注塑'
                }else if(row.ProcessStage === 2){
                  return '配件'
                }else if(row.ProcessStage === 0){
                  return '无'
                }else if(row.ProcessStage === 4){
                  return '组装'
                }
              
              })()  }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="ProduceTypeName"
        label="存货类型"
        min-width="110"
        align="center"
      >
         <template slot-scope="{ row }">
            <span>{{row.ProduceTypeName}}</span>
          </template>
      </el-table-column>
      <el-table-column
        prop="Remarks"
        label="备注"
        min-width="110"
        align="center"
      >
      </el-table-column>
    </el-table>
    </div>
    <!-- <bom-dialog
      ref="bomDialog"
      :columns="columns"
      :item="tempItem"
      :inner-columns="innerColumns"
      @saved="saved"
    ></bom-dialog> -->
    <come-list-dialog @select="comeSelect" ref="comeListDialog" in-dialog />
   <img-dialog ref="imgDialog" :imgs="imgs" />
    <list-dialog ref="listDialog" selectable :multiple="false" @select="listDialogSelect"></list-dialog>
    <detail-dialog ref="detailDialog" @saved="detail_saved"></detail-dialog>
  </div>
</template>

<script>
import accountSelect from '@/components/production/clothmanagement/cloth/select'
import bomDialog from './bomDialog'
import comeListDialog from "@/components/basedata/business/come/listDialog";
import imgDialog from './imgDialog'
import listDialog from '@/components/production/craftsmanship/solutions/assembly/listDialog'
import detailDialog from "./detailDialog";
import { urlHttp } from './bomConfig'


export default {
  name: "wjAssemble",
  components: {
    bomDialog,
    accountSelect,
    comeListDialog,
    imgDialog,
    listDialog,
    detailDialog,
  },
  props: {
    assembling: {
      type: Array,
      default: () => []
    },
    productData: {
      type: Array,
      default: () => []
    },
    processListProp:{
      type: Array,
      default: () => []
    },

  },
  watch: {
    assembling(data){
      console.log('====assembling data====', data)
      let arr = [];
      let ProcessData = [];
      let detailData = [];
      data.forEach(item => {
        let {DetailModels, ProcessModels, ...rest} = item;
        arr.push(rest);
        ProcessModels.forEach(v => {
          v.ProductName = rest.ProductName;
          v.ProductNo = rest.ProductNo;
        })
        ProcessData.push(...ProcessModels);
        let o = {
          name: rest.ProductName,
          DetailModels
        }
        detailData.push(o)
      })
      this.tableData = arr;
      this.ProcessData = ProcessData;
      this.detailData = detailData;
    },
    
  },
  data() {
    return {
      tableData: [],
      ProcessData: [],
      detailData: [],
      tableData: [],

      tempItem: {},
      pdApi: require('@/api/ba/product').default,
      propertyApi: require('@/api/ba/property').default,
      teProcessApi: require('@/api/production/teProcess').default,
      processList: [],
      initDAccount:[],
      propertyList: [],
      initTotal:0,
      DAccount: [],
      listTotal:0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      imgs: [],
      currentRow: null,
      craftData: [],
      subTableData: [],
      delTable: [],
      delCraftData: [],
      columns: [
        {
          key: "Pname",
          prop: "Pname",
          lable: "产品名称",
        },
        {
          key: "ProductSpec",
          prop: "ProductSpec",
          lable: "规格",
        },
        {
          key: "PdUnitName",
          prop: "PdUnitName",
          lable: "单位",
        },
        {
          key: "ColorName",
          prop: "ColorName",
          lable: "颜色",
        },
        {
          key: "ImgUrl",
          prop: "ImgUrl",
          lable: "图片",
        },
         {
          key: "ProcessStage",
          prop: "ProcessStage",
          lable: "加工阶段",
        },
        {
          key: "ProduceTypeName",
          prop: "ProduceTypeName",
          lable: "存货类型",
        },
        {
          key: "Bomno",
          prop: "Bomno",
          lable: "BOM版本",
        },
      ],
      innerColumns: [
        {
          key: "ProductNo",
          prop: "ProductNo",
          lable: "子件编码",
        },
        {
          key: "ProductName",
          prop: "ProductName",
          lable: "子件名称",
        },
        {
          key: "ProductSpec",
          prop: "ProductSpec",
          lable: "规格",
        },
        {
          key: "PdUnitName",
          prop: "PdUnitName",
          lable: "单位",
        },
        {
          key: "PropertyName",
          prop: "PropertyName",
          lable: "属性",
        },
        {
          key: "ColorName",
          prop: "ColorName",
          lable: "颜色",
        },
        {
          key: "ImgUrl",
          prop: "ImgUrl",
          lable: "图片",
        },
        {
          key: "ProcessStage",
          prop: "ProcessStage",
          lable: "加工阶段",
        },
        {
          key: "ProduceTypeName",
          prop: "ProduceTypeName",
          lable: "存货类型",
        },
      ]
    };
  },
  created(){
    // this.pdApi.list({Status: 1}).then(res => {


    //   if(res.Code === 0){
    //     let data = res.Data.filter(item => {
    //       return item.ProcessStage !== 3 && item.ProcessStage !== 4 
    //     })
    //     this.DAccount = data;
    //     this.initDAccount = data;
    //     this.listTotal = data.length;
    //     this.initTotal = data.length;
    //   }
      
    // })

    let propertyList = JSON.parse(localStorage.getItem('propertyList'))
    this.propertyList = propertyList;

    // this.propertyApi.list({Status: 1}).then(res => {
    //   if(res.Code === 0){
    //     this.propertyList = res.Data;
    //   }
    // })

    // this.teProcessApi.list({}).then(res => {
    //   if(res.Code === 0){
    //     this.processList = res.Data;

    //   }
    // })
  },
  methods: {
    changeProgramme(row){
      this.currentRow = row
      this.$refs.listDialog.open()
    },
    changeProgrammeInfo(row){
      this.currentRow = row
      this.$refs.detailDialog.open().then(that => {
        that.setTableData(row)
      })
      console.log('row', row)
    },
    listDialogSelect(list){
      this.currentRow.ProgrammeName = list.ProgrammeName;
      this.currentRow.Processes = list.Processes;
      this.currentRow.ProgrammeId = list.ProgrammeId;
      // this.currentRow.T = 1
    },
    detail_saved(list){
      this.currentRow.Processes = list;
      // this.currentRow.T = 1
    },
    selectCome(row){
      this.currentRow = row;
      this.$refs.comeListDialog.open();
    },
    comeSelect(row) {
      this.currentRow.TradeUnitId = row.TradeUnitId;
      this.currentRow.FullName = row.FullName;
    },
    delProcess(index, o = null){

      let row = this.craftData[index];
      if(row){
        row.T = 2;

        this.delCraftData.push(row);
        if(o){
          this.craftData.splice(index, 1, o);
        }else{
          this.craftData.splice(index, 1);

        }
      }
    
     

    },
    setCraftData(data){
      let arr = [];

      if(data.length !== 0){
        data.forEach(item => {
          item.ProcessModels.forEach(v => {
            v.T = 1
          })
        })

        data.forEach(item => {
          let o = {
            ProductName: item.Pname,
            ProductNo: item.Pno,
            ProgrammeId: item.ProcessModels[0].ProgrammeId,
            ProgrammeName: item.ProcessModels[0].ProgrammeName,
            Processes: item.ProcessModels
          }
          arr.push(o)
        })
      
        this.craftData = arr;
      }else{
         this.craftData = [];
      }

      

      
    },
    onSelect(e,row, index){

      if(row.T !== 0){
        row.T = 1
      }
      console.log('wjAssemble e========', e)
      row.ColorId = null;
      row.ProductName = e.ProductName;
      row.ProductNo = e.ProductNo;
      row.ProductSpec = e.ProductSpec;
      row.ProcessStage = e.ProcessStage;
      row.ProduceTypeName = e.ProduceTypeName;
      row.ProductId = e.ProductId;
      row.Mould = e.Mould;
      row.MouldId = e.MouldId;
      row.MouldName = e.MouldName;
      row.Colors = e.Colors

      row.UseProcess = e.UseProcess;
      row.UseColor = e.UseColor;
      row.PdUnitName = e.PdUnitName;
      row.PdUnitId = e.PdUnitId;

      row.Property = null


       if(row.ProcessStage === 2) {
          this.$emit('change', index, {
            ProductName: e.ProductName,
            ProductNo: e.ProductNo,
            ProgrammeName: '',
            ProgrammeId: null,
            Processes: [],
          });
        }else if(row.PropertyName === '注塑' && row.ProcessStage === 1){
          this.$emit('change-glue', index, {
            ProductName: e.ProductName,
            ProductNo: e.ProductNo,
            ProgrammeName: '',
            ProgrammeId: null,
            Processes: [],
          });
        }


    },
    resetFun(){
      this.pageParams.pageIndex=1
      this.DAccount=this.initDAccount
      this.listTotal=this.initTotal
    },
    currentPage(val){
      
      this.pageParams.pageIndex=val
          this.pdApi.list({ Status: 1 }).then((res) => {
            if (res.Code == 0) {
            this.DAccount = res.Data;
            this.listTotal=res.Count
            }
      });
    },
    inputText(text){
       this.pdApi.list({ProductName:text}).then((res) => {
            if (res.Code == 0) {
            this.DAccount = res.Data;
            this.listTotal=res.Count
            }
          });
    },
     processChange(row){ 
      let id = row.ProcessId;
      let ids = this.processList.map(item => {
        return item.ProcessId
      })
      let index = ids.indexOf(id);
      row.Sn = this.processList[index].Sn;

    },
    
    get_data(){ // 父组件获取装配阶段子列表
      let datas = [];
     
      this.subTableData.forEach((item) => {

        let child = [];
        item.child.forEach(item => {
          console.log('UseProcess---item', item)
         
          let o = {
            UseProcess: item.UseProcess,
            UseColor: item.UseColor,
            ColorId: item.ColorId,
            ColorName: item.ColorName,
            PropertyName: item.PropertyName,
            Colors: item.Colors,
            ImgUrl: item.ImgUrl,
            Imgs: item.Imgs,
            PdUnitId: item.PdUnitId,
            PdUnitName: item.PdUnitName,
            Pname: item.Pname,
            Pno: item.Pno,
            Remarks: item.Remarks,
            TeProductId: item.TeProductId,
            ProcessStage: item.ProcessStage,
            ProduceTypeName: item.ProduceTypeName,
            ProductId: item.ProductId,
            ProductName: item.ProductName,
            ProductNo: item.ProductNo,
            ProductSpec: item.ProductSpec,
            Property: item.Property,
            Quantity: item.Quantity,
            MouldId: item.MouldId,
            MouldNo: item.MouldNo,
            MouldName: item.MouldName,
          }
          console.log('o', o)
          child.push(o)

        })
        datas.push(...child);
      });
      

      return datas;
    },
     setSubTableData(arr) {
      // 父组件调用，设置子件列表
      console.log(arr,'arr')
      this.subTableData = arr;
    },
    add(list) {
       list.child.push({
          T: 0,
          ColorId: null, 
          ColorName: "",
          UnitId: "", 
          Quantity: 0,
          Remarks: "",
          Property: "",
          PropertyName: "",

  
          AddTime: "",
          AddUserId: "",
          AddUserName: "",
          BaseUnitId: "",
          BatchNumber: "",
          ClassId: "",
          ClassName: "",
          Colors: "",
          DefaultSupplier: "",
          DefaultWarehouse: "",
          ExpireDay: "",
          GoldenTaxCode: "",
          GrossWeight: "",
          HasExpire: "",
          IdChain: "",
          ImgUrl: "",
          LeadTime: "",
          MaxStock: "",
          MinStock: "",
          Mould: "",
          MouldId: "",
          MouldName: "",
          MouldRubberId: "",
          NetWeight: "",
          PdUnitId: "",
          PdUnitName: "",
          ProcessStage: "",
          ProduceTypeName: "",
          ProductId: "",
          ProductName: "",
          ProductNo: "",
          ProductSpec: "",
          ProductStatusId: "",
          ProductType: "",
          PuUnitId: "",
          PuUnitName: "",
          Rate: "",
          RpUnitId: "",
          RpUnitName: "",
          SaUnitId: "",
          SaUnitName: "",
          SafetyStock: "",
          ShortName: "",
          SkUnitId: "",
          SkUnitName: "",
          Sn: "",
          Status: "",
          StatusName: "",
          TradeUnitFullName: "",
          TradeUnitShortName: "",
          UnitGroupId: "",
          UnitType: "",
          Units: "",
          UpdateTime: "",
          UpdateUserId: "",
          UpdateUserName: "",
          UseColor: "",
          UseProcess: "",
          ValuationId: "",
          ValuationName: "",
          Volume: "",
          WarehouseName: "",
          WarehouseNo: "",
      })
    },
    select(item, index) {
     
      let Pname = this.tableData[index].ProductName;
      this.tempItem = item;
      console.log(Pname,'Pname')
      this.$refs.bomDialog.open().then(that => {
        that.getList(3, Pname);
      })
    },
    base64ToFile(dataurl, filename) {//将base64转换为文件
      var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while(n--){
          u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {type:mime});
    },
    async viewImg(row) {
      const res = await this.pdApi.productImgList(row.ProductId)
      if (res.Code != 0) return this.$message.warning(res.Msg);
      const ImgUrl = res.Data;
      if (!ImgUrl || ImgUrl?.length < 1) return this.$message.warning('无图片！');
      let imgs = [];
      ImgUrl.forEach(item => {
        // const imgBlob = URL.createObjectURL(this.base64ToFile(item.ImgUrl));
        // imgs.push(imgBlob);
        imgs.push('/api' + item.ImgUrl)
      })
      this.imgs = imgs;
      this.$refs.imgDialog.open();
    },
    del(row, index, list) {
      this.$confirm("确定删除这些记录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(res => {
        if(row.T !== 0){
          row.T = 2
        }
        this.delTable.push(row)
        console.log('this.delTable', this.delTable)
        list.child.splice(index, 1);

        if(row.ProcessStage === 2) {
          this.$emit('change', index);
        }else if(row.PropertyName === '注塑' && row.ProcessStage === 1){
          this.$emit('change-glue', index);
        }


      })
    },
    saved(list, item){
      item.child = [];
      this.$nextTick(() => {
        item.child.push(...list);
        this.$emit('change');
      })
    },
    changeColor(val, row){
      let ids = row.Colors.map(item => {
        return item.ColorId
      })
      let index = ids.indexOf(val);
      let color = row.Colors[index];
      
      row.ColorId = color.ColorId;
      row.ColorName = color.ColorName;
      if(row.T !== 0){
        row.T = 1
      }
      this.$emit('change');


    },
    changeQuantity(val, row){
      if(row.T !== 0){
        row.T = 1
      }
      this.$emit('change');

    },
    changeProperty(val, row){
      
      let ids = this.propertyList.map(item => {
        return item.PropertyId
      })
      let index = ids.indexOf(val);
      let property = this.propertyList[index];
      
      row.PropertyId = property.PropertyId;
      row.PropertyName = property.PropertyName;

      if(row.T !== 0){
        row.T = 1
      }

      this.$emit('change');

    },
    changeRemarks(row){
      if(row.T !== 0){
        row.T = 1
      }
      this.$emit('change');
    },
    
    getProcess(Processes, mode){
      let arr = [];
      Processes.forEach(item => {

        let {
          T,
          DpId,
          ProcessId,
          ProcessName,
          ProcessNo,
          ProcessType,
          ProcessSn,
          ProgrammeId,
          ProgrammeName,
          Stage,
          TeProductProcessId = 0,
          TebomId = 0,
          BomType = 3,
        } = item;
        BomType = 3

        let o = {}

        if(mode === 0){
          o = {
            T,
            DpId,
            ProcessId,
            ProcessName,
            ProcessNo,
            ProcessType,
            ProgrammeId,
            ProcessSn,
            ProgrammeName,
            Stage,
            TeProductProcessId,
            TebomId,
            BomType,
          }
        }else{
          o = {
            DpId,
            ProcessId,
            ProcessName,
            ProcessNo,
            ProcessType,
            ProcessSn,
            ProgrammeId,
            ProgrammeName,
            Stage,
            TeProductProcessId,
            TebomId,
            BomType,
          }
        }

        arr.push(o);
         
      })

      return arr
    },
    getProgramme(mode = 0){
      let arr = [];
      this.craftData.forEach(item => {
        let ProcessModels =  this.getProcess(item.Processes, mode)
        let o ={
          ProcessModels,
          ProgrammeId: item.ProgrammeId ? item.ProgrammeId : 0
        }
        arr.push(o)
      })

      return arr
    },
    getDetailModels(index, mode = 0, _TebomId) {
      let child = this.subTableData[index].child;

      let DetailModels = [];
      child.forEach((item) => {
        console.log("item", item);

        if(mode === 0){
          if(item.T != null){
            let {
              T,
              ProductId,
              ColorId = 0,
              Property = 0,
              Quantity,
              ProductNo,
              ProductName,
              ProcessStage,
              ProductSpec,
              Remarks,
              ColorName,
              TeProductDetailId = 0,
              TebomId = 0,
              BomType = 3,
            } = item;
            BomType = 3;
            Quantity = Number(Quantity);
            if(Property == null){
              Property = 0;
            }
            ColorId = ColorId ?? 0;

          let o = {
            T,
            ProductId,
            ColorId,
            Property,
            Quantity,
            ProductNo,
            ProductName,
            ProcessStage,
            ProductSpec,
            ColorName,
            TeProductDetailId,
            Remarks,
            TebomId,
            BomType,
          };

            DetailModels.push(o);
          }
        }else{
          let {
              ProductId,
              ColorId = 0,
              Property = 0,
              Quantity,
              ProductNo,
              ProductName,
              ProcessStage,
              ProductSpec,
              TeProductId = 0,
              Remarks,
              ColorName,
              TeProductDetailId = 0,
              TebomId = 0,
              BomType = 3,
            } = item;
            BomType = 3;
            Quantity = Number(Quantity);
            if(Property == null){
              Property = 0;
            }
            ColorId = ColorId ?? 0;

          let o = {
            ProductId,
            ColorId,
            Property,
            Quantity,
            ProductNo,
            ProductName,
            ProcessStage,
            TeProductId,
            ProductSpec,
            ColorName,
            TeProductDetailId,
            Remarks,
            TebomId,
            BomType,
          };

          DetailModels.push(o);
        }
          
        
      });


      if(mode === 0){
        this.delTable.forEach(item => {

          if(_TebomId === item.TebomId){
            let {
              T,
              ProductId,
              ColorId = 0,
              Property = 0,
              Quantity,
              ProductNo,
              ProductName,
              BomType = 4,
              Remarks,
              ProcessStage,
              ProductSpec,
              ColorName,
              TeProductDetailId = 0,
              TebomId = 0,
            } = item;
            BomType = 4
            Quantity = Number(Quantity);
            if(Property == null){
              Property = 0;
            }
            ColorId = ColorId ?? 0;

            let o = {
              T,
              ProductId,
              ColorId,
              Property,
              Quantity,
              ProductNo,
              ProductName,
              Remarks,
              ProcessStage,
              BomType,
              ProductSpec,
              ColorName,
              TeProductDetailId,
              TebomId,
            };

            DetailModels.push(o);
          }
          
        })
      }

      return DetailModels;
    },
    getSaveData(mode = 0) {
      let BomModels = [];
      let bool = true;
      this.tableData.forEach((item, index) => {
        let {
          ProductId,
          ColorId = 0,
          Bomno,
          Quantity,
          ProductName,
          ProductNo,
          ColorName,
          ProduceTypeName,
          Remarks = "",
          ProcessStage,
          ProductSpec,
          TebomId = 0,
          BomType = 3,
        } = item;
        Quantity = Number(Quantity);
        ColorId = ColorId ?? 0;
        BomType = 3
        if(Bomno == null || Bomno == ""){
          this.$message({type: 'warning', message: '请填写装配BOM版本'})
          bool = false
        }

        let DetailModels = this.getDetailModels(index, mode, TebomId);
         console.log('DetailModels===', DetailModels)


         if(mode === 1 && DetailModels.length === 0){
          bool = false
        }

        let Programme = this.getProgramme(mode);
        Programme = Programme.concat(this.delCraftData)
        

        if(mode === 1){
          Programme.forEach(item => {
            if(item.ProgrammeId == 0){
              bool = false;
            }
          })
        }

        

        let o = {
          DetailModels,
          ProductId,
          ColorId,
          Bomno,
          Quantity,
          Remarks,
          ProgrammeId: Programme[index] ? Programme[index].ProgrammeId : 0,
          ProcessModels: Programme[index] ? Programme[index].ProcessModels : [],
          ProductName,
          ProductNo,
          ColorName,
          ProduceTypeName,
          ProcessStage,
          ProductSpec,
          TebomId,
          BomType,
        };
        BomModels.push(o);
      });

      console.log('装配 BomModels', BomModels)


      if(bool){
        return BomModels;
      }else{
        return []
      }
    },
    cppyDetailModels(index){
       let child = this.subTableData[index].child;

      let DetailModels = [];
      child.forEach((item) => {
        console.log("item", item);

        let {
            T,
            ProductId,
            ColorId,
            Property = 0,
            Quantity,
            ProductNo,
            ProductName,
            ProcessStage,
            ProductSpec,
            Remarks,
            ColorName,
            TeProductDetailId = 0,
            TebomId = 0,
            BomType = 3,
          } = item;
          BomType = 3;
          ColorId = ColorId ?? 0;
          Quantity = Number(Quantity);
          if(Property == null){
            Property = 0;
          }

          let o = {
            T,
            ProductId,
            ColorId,
            Property,
            Quantity,
            ProductNo,
            ProductName,
            ProcessStage,
            ProductSpec,
            ColorName,
            TeProductDetailId,
            Remarks,
            TebomId,
            BomType,
          };

          DetailModels.push(o);
          
        
      });


    

      return DetailModels;
    },
    copyData(mode = 0) {
      let BomModels = [];
      let bool = true;
      this.tableData.forEach((item, index) => {
        let {
          ProductId,
          ColorId,
          Bomno,
          Quantity,
          ProductName,
          ProductNo,
          ColorName,
          ProduceTypeName,
          Remarks = "",
          ProcessStage,
          ProductSpec,
          TebomId = 0,
          BomType = 3,
        } = item;
        Quantity = Number(Quantity);
        ColorId = ColorId ?? 0;
        BomType = 3
        if(Bomno == null || Bomno == ""){
          this.$message({type: 'warning', message: '请填写装配BOM版本'})
          bool = false
        }

        let DetailModels = this.cppyDetailModels(index);
         console.log('DetailModels===', DetailModels)


         if(mode === 1 && DetailModels.length === 0){
          bool = false
        }

        let Programme = this.getProgramme(mode);
        Programme = Programme.concat(this.delCraftData)
        

        if(mode === 1){
          Programme.forEach(item => {
            if(item.ProgrammeId == 0){
              bool = false;
            }
          })
        }

        

        let o = {
          DetailModels,
          ProductId,
          ColorId,
          Bomno,
          Quantity,
          Remarks,
          ProgrammeId: Programme[index] ? Programme[index].ProgrammeId : 0,
          ProcessModels: Programme[index] ? Programme[index].ProcessModels : [],
          ProductName,
          ProductNo,
          ColorName,
          ProduceTypeName,
          ProcessStage,
          ProductSpec,
          TebomId,
          BomType,
        };
        BomModels.push(o);
      });

      console.log('装配 BomModels', BomModels)


      if(bool){
        return BomModels;
      }else{
        return []
      }
    },
  },
};
</script>

<style lang="scss" scoped>
 .flex{
  display: flex;
 }
</style>

